import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import { configuration } from "./config";

const { languages } = configuration;

// WCAG 3.1.1 - the page language has to be programmatically available, and here it also has to
// follow the deck language the game switches to mid-session.
//
// Deliberately not set statically in public/index.ejs: the "htmlTag" detector runs first in the
// order below, so a lang baked into the template would outrank the cookie, localStorage and
// browser language and pin everyone to it. Setting it after detection keeps detection untouched.
const applyDocumentLanguage = (language) => {
  if (language) {
    const [baseLanguage] = language.split("-");
    document.documentElement.lang = baseLanguage;
  }
};

i18next.on("languageChanged", applyDocumentLanguage);

i18next
  .use(LanguageDetector)
  .init({
    debug: languages.ui.debug || false,
    detection: {
      caches: languages.ui.cache.sources,
      lookupCookie: languages.ui.cache.key,
      lookupLocalStorage: languages.ui.cache.key,
      order: ["htmlTag", "cookie", "localStorage", "navigator"],
    },
    fallbackLng: languages.ui.fallback,
    interpolation: { escapeValue: false },
    load: "languageOnly",
    lowerCaseLng: true,
    resources: languages.ui.resources,
  });

export { i18next as i18n };
